import * as React from 'react'
import ReadService from "../../service/read";
import Wait from "../wait";
import PopDetail from "../popdetail";
import AddNewDeedPlan from "../add/add_new_deed_plan";
import AddDeedPlanSpatialPane from "../add/add_deed_plan_spatial";

export default class DeedPlanInfoListPane extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show_actions: this.props.can_edit ? 'table-cell' : 'none'
        }
        this.loadData = this.loadData.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }


    render() {

        return (<div className={'row'}>
            <div className={'col col-sm-12'} style={{padding:0}}>
                <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                        Deed Plan Info
                    </span>



                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

                <div style={{height: '60vh'}}>

                    <button style={{float: 'right', margin: '16px 4%'}} className={'btn submit'} onClick={()=>PopDetail.show('Add New Deed Plan',
                        <AddNewDeedPlan project={this.props.project} key={new Date().getMilliseconds()} loadData={()=>this.loadData()}/>,40)}>
                        <span className={'fa fa-plus'}/>Add New
                    </button>

                    <table className={'tb'} style={{width:'94%',margin:'2%'}}>
                        <thead>
                        <tr>
                            <th style={{width:'50px'}}>#.</th>
                            <th>Created Date</th>
                            <th>Deed Plan Name</th>
                            <th>SRID</th>
                            <th>Village</th>
                            <th>Total Plots</th>
                            <th style={{textAlign:'right'}}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>

                        {this.state.data.map((d,i)=>{
                            return(<tr key={i} className={'tr'} style={{cursor:'pointer'}} title={d.description}>
                                <td>
                                    <div style={{width:'14px',float:'left'}}>
                                        {i+1}.
                                    </div>
                                    <input type={'checkbox'} style={{marginLeft:'8px'}}/>
                                </td>
                                <td>{d.created_date}</td>
                                <td>
                                    <b style={{color:'darkcyan'}}>{d.name}</b>
                                </td>
                                <td>{d.srid}</td>
                                <td>{d.village}</td>
                                <td>{d.plots}</td>
                                <td style={{textAlign:'right',width:'180px'}}>
                                    {/*<button className={'btn'} onClick={()=>PopDetail.show('Add Spatial '+d.name,
                                        <AddDeedPlanSpatialPane loadData={()=>this.loadData()} deedplan={d} key={new Date().getMilliseconds()}/>,40)}>
                                        <span className={'fa fa-plus'}/>
                                        Spatial
                                    </button>*/}
                                    <button className={'btn error'}>
                                        <span className={'fa fa-trash'}/>
                                        Delete
                                    </button>
                                </td>
                            </tr>)
                        })}
                        </tbody>
                    </table>
                </div>

            </div>


        </div>)
    }


    loadData() {
        try {
            Wait.show('Fetching Deed plan....')
            ReadService.fetchDeedPlanInfo(this.props.project.id).then(r=>{
                Wait.dismiss()
                this.setState({
                    data:r.data.results
                })
            })
        }catch (e) {

        }
    }
}
